import { render, staticRenderFns } from "./InnerBanner.vue?vue&type=template&id=b20554aa&scoped=true&"
import script from "./InnerBanner.vue?vue&type=script&lang=js&"
export * from "./InnerBanner.vue?vue&type=script&lang=js&"
import style0 from "./InnerBanner.vue?vue&type=style&index=0&id=b20554aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20554aa",
  null
  
)

export default component.exports